import { connect } from 'react-redux';
import ChapterReflection from '../components/ChapterReflection';

const mapStateToProps = state => ({
  bookId: state.book.book ? state.book.book.id : 0
});

export default connect(mapStateToProps)(ChapterReflection);



// WEBPACK FOOTER //
// ./src/containers/ChapterReflectionContainer.js